module.exports = __webpack_public_path__ + "static/darwin-02-2fbe1052241c456fa560e690d08b17f5.jpg";